// import { useResizeObserver } from "src/hooks";
import CtaSection from "./sections/CtaSection";
import IntroSection from "./sections/IntroSection";
import ProcessSection from "./sections/ProcessSection";
import TracksSection from "./sections/TracksSection";

const WelcomePage = () => {


  return (
    <div className="w-100">
      <IntroSection />
      <TracksSection />
      <ProcessSection />
      <CtaSection />
    </div>
  );
};

export default WelcomePage;
